<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">

    <div class="container-fluid container-p-x pb-3">
        <b-row>
            <div class="col-12 col-md-7 pt-3 text-center text-md-left" style="font-size:12px">
                ⓒ 2022 Hoggard Technology | Sonido Software <span class="ml-3">All rights reserved.</span>
            </div>
            <div class="col-12 col-md-5 text-center text-md-right" style="font-size: 12px">
                <a href="https://www.mysonido.com/user-license-agreement/" class="footer-link pt-3" target="_blank">User License Agreement</a>
                <a href="https://www.mysonido.com/privacy-policy/" class="footer-link pt-3 ml-4" target="_blank">Privacy Policy</a>
            </div>
        </b-row>
    </div>


  </nav>
</template>

<script>
export default {
  name: 'app-layout-footer',

  methods: {
    getLayoutFooterBg () {
      return `bg-${this.layoutFooterBg}`
    }
  }
}
</script>
